/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useEffect, useState } from "react";
import { getProductByIdApi } from "../../services/_product";

interface Props {
  productId: string;
}

const ViewProduct: React.FC<Props> = ({ productId }) => {
  const [product, setProduct] = useState<any>({});

  useEffect(() => {
    if (productId) {
      setProduct({});
      getProductDetails();
    }
  }, [productId]);

  const getProductDetails = async () => {
    const result: any = await getProductByIdApi(productId as string);
    if (result.isSuccess) {
      setProduct(result?.data);
    }
  };

  return (
    <div
      className="modal fade"
      id="viewProduct"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-simple modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body pt-0 pb-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="text-center">
              <h4 className="mb-0">Product Details</h4>
            </div>
            <div className="info-container">
              <div className="pb-4 border-bottom text-capitalize mb-4"></div>
              <ul className="list-unstyled mb-6">
                <li className="mb-2">
                  <span className="h6 me-1">Name:</span>
                  <span>{product?.name}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Variety:</span>
                  <span>{product?.variety}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">HSN No:</span>
                  <span>{product?.hsn_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Description:</span>
                  <span>{product?.description}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Status:</span>
                  <span
                    className={`badge ${
                      product?.status ? "bg-label-success" : "bg-label-danger"
                    }`}
                  >
                    {product?.status ? "Active" : "Inactive"}
                  </span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Created At:</span>
                  <span>
                    {product?.created_at
                      ? moment(product?.created_at).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : ""}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProduct;
